/* LittleNookCo: gallery arrows, homepage gallery sizing, save % pills, sticky buy bar (homepage + product page) */
(function () {
  var ICON = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>'
  };

  function step(gallery, dir) {
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list .thumbnail'));
    if (thumbs.length > 1) {
      var i = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
      if (i < 0) i = 0;
      thumbs[(i + dir + thumbs.length) % thumbs.length].click();
      return;
    }
    var list = gallery.querySelector('.product__media-list');
    if (list) list.scrollBy({ left: dir * list.clientWidth, behavior: 'smooth' });
  }

  function sizeNookGalleries() {
    document.querySelectorAll('.nook-pg').forEach(function (g) {
      var img = g.querySelector('.nook-pg__slide img');
      if (!img) return;
      function apply() {
        var w = img.naturalWidth || parseInt(img.getAttribute('width'), 10);
        var h = img.naturalHeight || parseInt(img.getAttribute('height'), 10);
        if (w && h) g.style.setProperty('--nook-ar', w + ' / ' + h);
      }
      apply();
      if (!img.complete) img.addEventListener('load', apply, { once: true });
    });
  }

  // "Save 37%" pill next to each offer title, worked out from the card's own prices
  function savePills() {
    document.querySelectorAll('.nook-tier').forEach(function (t) {
      if (t.querySelector('.nook-tier__save')) return;
      var was = t.querySelector('.nook-tier__price s');
      var now = t.querySelector('.nook-tier__price strong');
      var title = t.querySelector('.nook-tier__title');
      if (!was || !now || !title) return;
      var num = function (el) { return parseFloat(el.textContent.replace(/[^0-9.]/g, '')); };
      var pct = Math.floor((1 - num(now) / num(was)) * 100);
      if (!(pct >= 5)) return;
      var pill = document.createElement('span');
      pill.className = 'nook-tier__save';
      pill.textContent = 'Save ' + pct + '%';
      title.appendChild(pill);
    });
  }

  function money(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
  }

  // once the real Add to cart button scrolls out of view, show a bar pinned to the bottom with the chosen offer
  // works on the homepage (.nook-pd) and on the product page (main product section with the offer cards)
  function mobileBar() {
    if (document.querySelector('.nook-mbar') || !('IntersectionObserver' in window)) return;
    var pd = document.querySelector('.nook-pd');
    if (!pd) {
      var offer = document.querySelector('.nook-offer');
      pd = offer && (offer.closest('.product__info-container') || offer.closest('section'));
    }
    if (!pd) return;
    var btn = pd.querySelector('.product-form__submit');
    if (!btn) return;
    var bar = document.createElement('div');
    bar.className = 'nook-mbar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="nook-mbar__info"><span class="nook-mbar__name"></span><span class="nook-mbar__price"></span></div><button type="button" class="nook-mbar__btn" tabindex="-1">Add to cart</button>';
    document.body.appendChild(bar);
    var nameEl = bar.querySelector('.nook-mbar__name');
    var priceEl = bar.querySelector('.nook-mbar__price');
    function update() {
      var sel = pd.querySelector('.nook-tier.is-selected .nook-tier__title');
      nameEl.textContent = sel ? sel.firstChild.textContent.trim() : 'The Tome Guardian';
      var m = (btn.textContent || '').match(/\$[\d,]+\.\d{2}/);
      if (m) { priceEl.textContent = m[0]; return; }
      var tier = pd.querySelector('input[name="nook-tier"]:checked');
      if (!tier) { priceEl.textContent = ''; return; }
      var total = parseInt(tier.dataset.price || '0', 10);
      var prot = pd.querySelector('.nook-offer__protect input:checked');
      if (prot) total += parseInt(prot.dataset.price || '0', 10);
      priceEl.textContent = money(total);
    }
    bar.querySelector('button').addEventListener('click', function () { btn.click(); });
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      document.body.classList.toggle('nook-mbar-on', past);
      update();
    }).observe(btn);
    pd.addEventListener('change', function () { setTimeout(update, 120); });
    update();
  }

  function init() {
    sizeNookGalleries();
    savePills();
    mobileBar();
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.dataset.nookArrows) return;
      var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
      var count = gallery.querySelectorAll('.product__media-list .product__media-item').length;
      if (!viewer || count < 2) return;
      gallery.dataset.nookArrows = '1';
      [['prev', -1, 'Previous photo'], ['next', 1, 'Next photo']].forEach(function (cfg) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nook-mg-arrow nook-mg-arrow--' + cfg[0];
        b.setAttribute('aria-label', cfg[2]);
        b.innerHTML = ICON[cfg[0]];
        b.addEventListener('click', function (e) { e.preventDefault(); step(gallery, cfg[1]); });
        viewer.appendChild(b);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
